import { render } from "./CustomerTag.vue?vue&type=template&id=2ee4ee25&ts=true"
import script from "./CustomerTag.vue?vue&type=script&lang=ts"
export * from "./CustomerTag.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__